export const getRuleTypeByModalTitle = element => {
	const modalTitle = element.parentElement.parentElement.querySelector("h4.modal-title").textContent;

	switch (modalTitle) {
	case "Visible": return "visible";
	case "Enabled": return "enable";
	case "Ignored": return "ignore";
	}
};

export const findInDomFieldValueByLabel = label => {
	// This function is used to find the value of a field in the form by its label.
	const inputs = Array.from(document.querySelectorAll("label.eo-vis-attribute-control-label"));
	// Find the label element that matches the label we are looking for.
	const fieldLabel = inputs.find(input => input.textContent === label);
	// Get the parent element of the label, which is the field.
	const field = fieldLabel.parentElement;
	// Get the textarea element inside the field.
	const textarea = field.querySelector("textarea");
	// If the textarea has the attribute "ckeditor-on-ready", return undefined - because it means textarea connected to ck-editor and has invalid value.
	if (textarea.hasAttribute("ckeditor-on-ready")) {
		return undefined;
	}

	// Otherwise, return the value of the textarea.
	return textarea.value;
};
